import { render, staticRenderFns } from "./ProfileClave.vue?vue&type=template&id=534680b0&"
import script from "./ProfileClave.vue?vue&type=script&lang=js&"
export * from "./ProfileClave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports